export default function reducer(
  state = {
    favorites: {},
    ps: {},
    detailsContent: {},
    appSearch: {
      query: '',
      results: [],
      active: false
    }
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_RPS_FAVORITES':
      return {
        ...state,
        favorites: action.favorites
      };
    case 'UPDATE_SEARCH_QUERY':
      return {
        ...state,
        appSearch: {
          ...state.appSearch,
          query: action.query
        }
      };
    case 'UPDATE_SEARCH_RESULTS':
      return {
        ...state,
        appSearch: {
          ...state.appSearch,
          results: action.results
        }
      };
    case 'CLEAR_SEARCH':
      return {
        ...state,
        appSearch: {
          ...state.appSearch,
          query: '',
          results: [],
          active: false
        }
      };
    case 'SET_SEARCH_ACTIVE':
      return {
        ...state,
        appSearch: {
          ...state.appSearch,
          active: action.value
        }
      };
    default:
      return { ...state };
  }
}
